import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const TOTAL_SCHEMA = Object.freeze({
  CURRENCY_CODE: '',
  OWED: 0,
});
const RECORD = generateSchema(TOTAL_SCHEMA);
const KEYS: any = generateKeys(TOTAL_SCHEMA);

export class Total extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get currencyCode(): string {
    return this.get(KEYS.CURRENCY_CODE);
  }

  get owed(): number {
    return this.get(KEYS.OWED);
  }
}
